import { Page, WalletHeading, PageSkeleton } from '@/components';
import ActivityTable from './ActivityTable';
import HistoricTabs from './HistoricTabs';
import { useParams } from 'react-router';
import { useSearchParams } from '@/hooks';
import { useApi } from '@/api';
import type { Wallet } from '../TopKpis';

export default function WalletActivityPage() {
  const { walletAddress, network } = useParams() as {
    walletAddress: string;
    network: string;
  };
  const [date] = useSearchParams('date', '');
  const [data, error] = useApi<Wallet>({
    url: `/wallets/${walletAddress}/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <PageSkeleton />;
  }

  return (
    <Page>
      <WalletHeading
        walletAddress={walletAddress}
        totalSupply={data.total_supply}
        totalBorrow={data.total_borrow}
        healthRate={data.health_rate}
        network={network}
      />

      {!date ? <HistoricTabs /> : null}

      <ActivityTable
        walletAddress={walletAddress}
        network={network}
        forDate={date}
      />
    </Page>
  );
}
